// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quizSelected {
  background-color: #c48857;
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  border-radius: 6px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  padding: 2%;
  cursor: pointer;
}

.quizNotSelected {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  border-radius: 6px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  padding: 2%;
  cursor: pointer;
}
.turn-white, .turn-grey {
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  margin-top: 2px;
  margin-bottom: 0;
}

.turn-grey {
  color: rgb(128, 128, 128);
}

.outer-div {
  width: 94%;
  height: 65px;
  background-color: #fff;
  border-radius: 6px;
  margin: 7px auto;
}

.left-div{
  display: flex;
  width: 22%;
  height: 100%;
  vertical-align: middle;
  justify-content: center;
  align-items: center;
}

.right-div{
  display: inline-block;
  width: 78%;
  height: 100%;
}
.search{
  margin: 2% auto;  
  width: 92%;
  display: block;
}
.search-div{
  display: block;
}

.quiz-status{
  overflow-y: auto;
  height: 88%;
}
.quiz-image{
  height: 48px;
}
.quiz-title{
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  padding:0;
 line-height:1;
 padding-bottom: 3px;
 font-size: 14px;
}
.loader-div{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80%;
}


`, "",{"version":3,"sources":["webpack://./src/components/modules/learners/quizStatus/quizStatus.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4EAA4E;EAC5E,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4EAA4E;EAC5E,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;AACd;AACA;EACE,eAAe;EACf,UAAU;EACV,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,SAAS;CACV,aAAa;CACb,mBAAmB;CACnB,eAAe;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb","sourcesContent":[".quizSelected {\n  background-color: #c48857;\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  height: 100%;\n  border-radius: 6px;\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  padding: 2%;\n  cursor: pointer;\n}\n\n.quizNotSelected {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  height: 100%;\n  border-radius: 6px;\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  padding: 2%;\n  cursor: pointer;\n}\n.turn-white, .turn-grey {\n  color: #fff;\n  font-size: 12px;\n  font-weight: 500;\n  margin-top: 2px;\n  margin-bottom: 0;\n}\n\n.turn-grey {\n  color: rgb(128, 128, 128);\n}\n\n.outer-div {\n  width: 94%;\n  height: 65px;\n  background-color: #fff;\n  border-radius: 6px;\n  margin: 7px auto;\n}\n\n.left-div{\n  display: flex;\n  width: 22%;\n  height: 100%;\n  vertical-align: middle;\n  justify-content: center;\n  align-items: center;\n}\n\n.right-div{\n  display: inline-block;\n  width: 78%;\n  height: 100%;\n}\n.search{\n  margin: 2% auto;  \n  width: 92%;\n  display: block;\n}\n.search-div{\n  display: block;\n}\n\n.quiz-status{\n  overflow-y: auto;\n  height: 88%;\n}\n.quiz-image{\n  height: 48px;\n}\n.quiz-title{\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  width: 100%;\n  padding:0;\n line-height:1;\n padding-bottom: 3px;\n font-size: 14px;\n}\n.loader-div{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 80%;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
